const translations = {
  de: {
    miradorSharePlugin: {
      addToAnotherViewer: 'Zu einem anderen Betrachter hinzufügen',
      ariaCopyCodeToClipboard: 'Code in die Zischenablage kopieren',
      ariaCopyManifest: 'Manifest in die Zwischenablage kopieren',
      ariaDragIcon: 'Icon in einen beliebigen IIIF-Viewer ziehen.',
      ariaSelectViewerSize: 'Größe des Viewers auswählen',
      ariaShareLinkUrl: 'URL teilen',
      ariaCopyToClipboard: 'Link in die Zwischenablage kopieren',
      buttonClose: 'Schließen',
      buttonCopy: 'Kopieren',
      copyAndPasteCode: 'Code kopieren und einfügen',
      copyAndPasteManifest: 'Manifest der Ressource kopieren und in einen beliebigen IIIF-Viewer einfügen.',
      embed: 'Einbetten',
      iconDragAndDrop: 'IIIF-Icon per Drag&Drop verwenden, um diese Ressource zu einem beliebigen IIIF-Viewer hinzuzufügen',
      menuItemShare: 'Teilen',
      selectViewerSize: 'Größe des Viewers auswählen',
      shareDialogTitle: 'Teilen',
      shareLink: 'Link teilen',
      snackbarCopiedCodeToClipboard: 'Code wurde in die Zwischenablage kopiert!',
      snackbarCopiedLinkToClipboard: 'Link wurde in die Zwischenablage kopiert!',
      snackbarManifestCopied: 'Manifest wurde in die Zwischenablage kopiert!',
      textOr: 'oder',
      whatIsIiif: 'Was ist IIIF?',
    },
  },
  en: {
    miradorSharePlugin: {
      addToAnotherViewer: 'Add to another viewer',
      ariaCopyCodeToClipboard: 'Copy code to clipboard',
      ariaCopyManifest: 'Copy manifest to clipboard',
      ariaDragIcon: 'Drag icon to any IIIF viewer.',
      ariaSelectViewerSize: 'Select viewer size',
      ariaShareLinkUrl: 'Share link URL',
      ariaCopyToClipboard: 'Copy link to clipboard',
      buttonClose: 'Close',
      buttonCopy: 'Copy',
      copyAndPasteCode: 'Copy & paste code',
      copyAndPasteManifest: "Copy & paste the resource's manifest into any IIIF viewer.",
      iconDragAndDrop: 'Drag & drop IIIF icon to add this resource to any IIIF viewer',
      embed: 'Embed',
      menuItemShare: 'Share',
      selectViewerSize: 'Select viewer size',
      shareDialogTitle: 'Share',
      shareLink: 'Share link',
      snackbarCopiedCodeToClipboard: 'Code copied to clipboard!',
      snackbarCopiedLinkToClipboard: 'Link copied to clipboard!',
      snackbarManifestCopied: 'Manifest copied to clipboard!',
      textOr: 'or',
      whatIsIiif: 'What is IIIF?',
    },
  },
};

export default translations;
